import moment from 'moment';

const ExecutiveSummaryMapper = {
  toReportData: executiveSummary => {
    return {
      commentary: executiveSummary.Commentary,
      totalUnitCount: executiveSummary.TotalUnitCount,
      demographic: {
        ohtPercentages: executiveSummary.Demographic.OhtPercentages.map(mapPercentageItem),
        deviceClassPercentages:
          executiveSummary.Demographic.DeviceClassPercentages.map(mapPercentageItem)
      },
      locations: executiveSummary.Locations.map(x => ({
        locationId: x.LocationId,
        rank: x.Rank,
        orgUnits: x.OrgUnits.map(x => ({
          name: x.Name,
          fei: x.Fei
        }))
      })),
      summary: {
        mostCommonLocations: executiveSummary.Summary.MostCommonLocations?.map(location => ({
          locationName: location.LocationName,
          percentage: location.Percentage
        })),
        highestOhts: executiveSummary.Summary.HighestOhts?.map(mapPercentageItem),
        highestDeviceClasses: executiveSummary.Summary.HighestDeviceClasses?.map(mapPercentageItem),
        yearsInVip: executiveSummary.Summary.YearsInVip,
        strengths: executiveSummary.Summary.Strengths?.map(mapStrengthChallengeItem),
        challenges: executiveSummary.Summary.Challenges?.map(mapStrengthChallengeItem)
      },
      timeline: executiveSummary.Timeline.map(x => ({
        timelineDate: x.TimelineDate ? moment(x.TimelineDate).toDate() : null,
        spacing: x.Spacing,
        type: x.Type,
        orgUnits: x.OrgUnits.map(group => ({
          participationYears: group.ParticipationYears,
          units: group.Units.map(u => ({
            name: u.Name,
            fei: u.Fei
          }))
        }))
      }))
    };
  },

  toCommentaryInput: (orgId, commentary) => ({
    orgId: orgId,
    commentary: commentary
  })
};

const mapPercentageItem = item => ({
  name: item.Name,
  value: item.Value
});

const mapStrengthChallengeItem = item => ({
  percentage: item.AggregatePercentage,
  label: formatPracticeArea(item)
});

const formatPracticeArea = item => `${item.Acronym} ${item.GroupLevel}.${item.NumberWithinLevel}`;

export default ExecutiveSummaryMapper;
